import * as React from "react"
import {
  GeneralIcon,
  IntegrationsIcon,
  BuildsIcon,
  SkullIcon,
  ReportsIcon,
  HostingIcon,
} from "gatsby-interface"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import { getSiteDetailsTabBasePath } from "../../details/utils"
import { SiteDetailsTab } from "../../details/constants"
import getSideNavOptions from "../../../layout/utils/getSideNavOptions"
import { MdVisibility } from "react-icons/md"

const siteSettings = [
  {
    id: SiteSettingsSection.General,
    Icon: GeneralIcon,
    subsections: [
      {
        id: SiteSettingsSection.SiteDetails,
      },
      {
        id: SiteSettingsSection.EnvVars,
      },
      {
        id: SiteSettingsSection.Webhook,
      },
      {
        id: SiteSettingsSection.ContentLoader,
      },
      {
        id: SiteSettingsSection.NotificationDeploys,
      },
      {
        id: SiteSettingsSection.VisitorAccess,
      },
    ],
  },
  {
    id: SiteSettingsSection.Builds,
    Icon: BuildsIcon,
  },
  {
    id: SiteSettingsSection.Preview,
    Icon: PreviewIcon,
  },
  {
    id: SiteSettingsSection.Hosting,
    Icon: HostingIcon,
    isNew: true,
  },
  {
    id: SiteSettingsSection.Reports,
    Icon: ReportsIcon,
  },
  {
    id: SiteSettingsSection.DataSources,
    Icon: IntegrationsIcon,
  },
  {
    id: SiteSettingsSection.Danger,
    Icon: SkullIcon,
  },
]

export function useSiteSettingsNavigation({
  organizationId,
  siteId,
  location,
  buildsEnabled,
}) {
  return getSideNavOptions({
    sections: siteSettings,
    sectionLabels: SiteSettingsSectionLabel,
    getLink: sectionId =>
      `${getSiteDetailsTabBasePath(
        SiteDetailsTab.Settings,
        siteId,
        organizationId
      )}/${sectionId}`,
    location,
    filterWith: sectionId => {
      if (sectionId === SiteSettingsSection.Reports) {
        return buildsEnabled
      }
      if (sectionId === SiteSettingsSection.HostingIntegrations) {
        return buildsEnabled
      }

      if (sectionId === SiteSettingsSection.Hosting) {
        return buildsEnabled
      }

      return true
    },
  })
}

function PreviewIcon(props) {
  return <MdVisibility {...props} size="1em" />
}
